import styled, { css } from 'styled-components';

// Styles
import { margin, padding } from '../../../assets/styles/props';
import { flex } from '../../../assets/styles/flex-grid';

export const SectionInnerWrapper = styled.div`
	${padding};
	${margin};
	max-width: 1600px;
	width: 100%;
`;

export const SectionOuterWrapper = styled.section`
	${flex};
	padding: 0 32px;
	height: auto;
	
	${props => `background-color: ${props.color}`}
	
	${(props) => {
		if (props.cut) {
			return `background: linear-gradient(to bottom, ${props.color} 0%,${props.color} 85%,${props.color} 85%,white 85%,white 100%);`;
		}
	}};
`;
